import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './parent-routes';
import { Forbidden, NotFound } from '@phrmpc/modules/error';

export const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '$',
  component: NotFound,
});

export const errorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'error/$type',
  component: Forbidden,
});
